import React from 'react';
import { Modal } from 'antd';
import './permission-instruction-modal.scss';

interface PermissionInstructionModalProps {
  visible: boolean;
  deviceName: string;
  instructions: string;
  isChrome: boolean;
  onClose: () => void;
}

const PermissionInstructionModal: React.FC<PermissionInstructionModalProps> = ({
  visible,
  deviceName,
  instructions,
  isChrome,
  onClose
}) => {
  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      footer={null}
      className="permission-instruction-modal"
      width={600}
      centered
      closable={true}
      maskClosable={true}
    >
      <div className="permission-instruction-content">
        <h2 className="instruction-title">
          Enable {deviceName === 'microphone' ? 'Microphone' : deviceName === 'camera' ? 'Camera' : 'Microphone and Camera'} Access
        </h2>

        {isChrome && (
          <div className="instruction-image-container">
            <img
              src="/images/permission/chrome.png"
              alt="Chrome permission instructions"
              className="instruction-image"
            />
          </div>
        )}

        <div className="instruction-text">
          <p className="instruction-description">
            Permission for {deviceName} was previously denied. Please follow these steps to enable access:
          </p>
          <div className="instruction-steps">
            {instructions.split('\n').map((step, index) => {
              if (!step.trim()) return null;
              // Check if it's a numbered step (starts with number)
              if (/^\d+\./.test(step.trim())) {
                return (
                  <div key={index} className="instruction-step">
                    {step.trim()}
                  </div>
                );
              } else {
                return (
                  <p key={index} className="instruction-paragraph">
                    {step.trim()}
                  </p>
                );
              }
            })}
          </div>
        </div>

        <div className="instruction-actions">
          <button className="instruction-close-btn" onClick={onClose}>
            Got it
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default PermissionInstructionModal;

